import { render, staticRenderFns } from "./POptionBarNew.vue?vue&type=template&id=4882605e&scoped=true"
import script from "./POptionBarNew.vue?vue&type=script&lang=ts"
export * from "./POptionBarNew.vue?vue&type=script&lang=ts"
import style0 from "./POptionBarNew.vue?vue&type=style&index=0&id=4882605e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882605e",
  null
  
)

export default component.exports